import { BaseEntityDto } from '@fleet-beat/core';
import { DriverDto } from '@fleet-beat/api';

export interface DotInspectionDaysDto extends BaseEntityDto {
  id?: string;
  driver?: DriverDto;
  startedAt?: string;
  endedAt?: string;
  processedAt?: string;
}
